// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 01/08/2023

import { Component } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, AuthService, CtDialogComponent, CtInputTextComponent, CtMessageComponent, CtOtpComponent, CtRadioComponent, CtRegexComponent, CtStepperComponent, CtStepperItemComponent, CtrlBaseComponent, EntityField, SpinnerService } from 'components';
import { Router } from '@angular/router';

@Component({
	selector: 'sg-vi01',
	template: `<div [id]="getId()" #target><div>`
})

export class SgVi01 extends BaseController {

	//constants
	private readonly PASSWORD_REQUIREMENTS_ERROR = "La contraseña no cumple con los requisitos de seguridad";
	private readonly PASSWORDS_DO_NOT_MATCH = "Las contraseñas no coinciden";
	private readonly ACCOUNT_NOT_ASSOCIATED_ERROR = "No hay ninguna cuenta asociada a la identificación ingresada";
	public readonly EMAIL_TEXT : string = 'Enviar un correo a ';
	public readonly SMS_TEXT : string = 'Enviar un mensaje de texto al ';
	private readonly NO_USER_CONTACTS = "Estimado(a) cliente, hemos identificado que no posee registrados medios de contacto. Le pedimos amablemente que actualice su información a través de los canales que la SSV pone a su disposición para garantizar una experiencia óptima.";

	//properties
	private ctStepper : CtStepperComponent;
	private otpComponent : CtOtpComponent;
	private confirmPasswordInput : CtInputTextComponent;
	private userIdentifier : string;

	constructor(private authService : AuthService,
		private router : Router,
		private spinnerService : SpinnerService) {
		super();
		this.setViewCode('SG_VI01');
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	
	/**
	 * Called from the first stepper item sets the contacts to the second stepperItem component
	 */
	public setContactsToStepper(action : Action): void {
		this.ctStepper = this.utilService.getComponentRef(action.actionParams[0]);
		const inputComponent : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const ctMessage : CtMessageComponent = this.utilService.getComponentRef(action.actionParams[2]);
		ctMessage.setHidden(true);
		this.getUserContacts(inputComponent, ctMessage);
	}


	/**
	 * Called from the second stepper item retrieves the selected readio, determines the type of
	 * OTP dispatch (email or phone), sets the data to the OTP component, sends the OTP code, and advances
	 * the stepper to the next step.
	 */
	public executeOtpDispatch(): void {
		const stepperItemRadio : CtRadioComponent[] = this.ctStepper.getChildElements()[1].getChildsByType(CtRadioComponent,true);
		const stepperItemOtp : CtOtpComponent[] = this.ctStepper.getChildElements()[2].getChildsByType(CtOtpComponent,true);
		this.otpComponent = stepperItemOtp[0];
		let type : string;
		let contactChecked : boolean = false;

		for(let radio of stepperItemRadio){
			if(!radio.getIsChecked()) continue;
			contactChecked = true;
			stepperItemOtp[0].setDataToOtp(radio.getValue().Value, radio.getValue().Name, this.userIdentifier);
		}

		if(!contactChecked) return;
		stepperItemOtp[0].sendCode();
		this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
	}

	/**
	 * Called from the OtpComponent only if the otp code was correct, advances the stepper to the final step
	 */
	public postOtpValidation(): void {
		this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
	}

	public validateOtpCode(): void {
		if(this.otpComponent.getOtpCodeFromInput() === '') return;
		this.otpComponent.validateOtpCode();
	}

	/**
	 * Called from the final stepper item, validates the new password and sends the request to the API
	 * to change the password
	 */
	public changePassword(action : Action): void {
		this.spinnerService.show();
		const otpCode : string = this.otpComponent.getOtpCodeFromInput();
		const childInputs : CtInputTextComponent[] = this.ctStepper.getChildElements()[3].getChildsByType(CtInputTextComponent,true);
		this.confirmPasswordInput = childInputs[1];
		
		if(!this.checkNewPasswordRequirements(childInputs)){
			this.spinnerService.hide();
			return;
		}

		this.authService.setNewPassword(this.userIdentifier, childInputs[0].getOldValue(), childInputs[1].getOldValue(), otpCode).subscribe({
			next: () => {
				this.spinnerService.hide();
				const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
				dialog.openDialog();
			},
			error: (error : any) => {
				this.spinnerService.hide();
				this.confirmPasswordInput.isValid = false;
				this.confirmPasswordInput.setRequiredMessage(error.error.Message);
			}
		});
	}

	public returnToLogin(): void {
		this.router.navigate(['/login']);
	}

	private checkNewPasswordRequirements(childInputs : CtInputTextComponent[]): boolean {
		childInputs[1].isValid = true;
		if(childInputs[0].getOldValue() !== childInputs[1].getOldValue()){
			childInputs[1].isValid = false;
			childInputs[1].setRequiredMessage(this.PASSWORDS_DO_NOT_MATCH);
			return false;
		}

		const invalidRegex : number = childInputs[0].getRegexComponents().filter((children : CtrlBaseComponent) => {
			if(children.getCtType() === 'CtRegex'){
				const regexComponent : CtRegexComponent = children as CtRegexComponent;
				return !regexComponent.getIsValid();
			}
		}).length;

		if(invalidRegex > 0){
			childInputs[0].isValid = false;
			childInputs[0].setRequiredMessage(this.PASSWORD_REQUIREMENTS_ERROR);
			return false;
		}

		return true;
	}

	private getUserContacts(inputComponent: CtInputTextComponent, ctMessage : CtMessageComponent) {
		const stepperItemRadio : CtStepperItemComponent = this.ctStepper.getChildElements()[1] as CtStepperItemComponent;
		this.userIdentifier = inputComponent.getOldValue();
		inputComponent.isValid = true;
		this.authService.getLoginPreviewInfoAuthSva(inputComponent.getOldValue()).subscribe({
			next: (response : any) => {
				let isUser : string = response['Data'][0].ArrayEntities.List.filter((element : EntityField) => element.Name === 'IS_USER')[0].Value;
				if(isUser === 'N'){
					inputComponent.isValid = false;
					inputComponent.setRequiredMessage(this.ACCOUNT_NOT_ASSOCIATED_ERROR);
				} else {
					this.setContactToStepperItem(response['Data'][0].ArrayEntities.List, stepperItemRadio, ctMessage);		
				}
			},
			error : (err : any) => {
				inputComponent.isValid = false;
				if(err.error_code === 'DMZ.ERR_DMZ_USER_DEAD'){
					inputComponent.setRequiredMessage(err.description);
				} else {
					inputComponent.setRequiredMessage(this.ACCOUNT_NOT_ASSOCIATED_ERROR);
				}
			}
		});
	}

	private setContactToStepperItem(arrayEntitiesList: EntityField[], stepperItem: CtStepperItemComponent, ctMessage : CtMessageComponent) {
		let radioComponentsMetadata : any[] = [];
		arrayEntitiesList = arrayEntitiesList.filter((element : EntityField) => element.Name === 'EMAIL' || element.Name === 'CELULAR');

		for(let [index, element] of arrayEntitiesList.entries()) {
			if(element.Value === '' ||
				element.Value === null || 
				element.Value === undefined ||
				element.Value.toUpperCase() === 'NULL') continue;
			radioComponentsMetadata.push(this.getRadioComponentMetadata(element, index, element.Name));
		}
		if(!this.checkUserContacts(radioComponentsMetadata, ctMessage)) return;
		this.paintRadioComponents(radioComponentsMetadata, stepperItem);
	}

	private checkUserContacts(radioComponentsMetadata: any[], ctMessage: CtMessageComponent) {
		if(radioComponentsMetadata.length === 0){
			ctMessage.setMessage(this.NO_USER_CONTACTS);
			ctMessage.setHidden(false);
			return false;
		}
		return true;
	}

	private getRadioComponentMetadata(element: EntityField, index : number, type : string): any {
		return {
			ctType: "CtRadio",
			controlProperties: {
			  hidden: false,
			  listenedComponentId: "",
			  listenedProperty: "",
			  border: true,
			  isChecked: false,
			  readOnly: false,
			  labelValue: type === 'EMAIL' ? this.EMAIL_TEXT + element.Value : this.SMS_TEXT + element.Value,
			  value: element,
			  descriptionValue: "",
			  familyValue: "userContacts",
			  id: `RESETPASSWORD_LOGIN_CONTACTS_${index}`,
			  modelId: ""
			},
			controlActions: [],
			models: []
		};
	}

	private paintRadioComponents(radioComponentsMetadata: any[], stepperItem: CtStepperItemComponent) {
		let metadata : any = stepperItem.getMetaData();
		metadata.models = radioComponentsMetadata;
		stepperItem.ngAfterViewInit();
		this.ctStepper.changeStep(this.ctStepper.getCurrentIndex() + 1);
	}
	/* -------------------- END CONTROLLER LOGIC ----------------- */
}